// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iFkc","largestCol":"styles_largestCol__3gAfa","smallestCol":"styles_smallestCol__1VVkS"};